<div class="empty-page">
  <div class="container text-center">
    <div class="empty-img"></div>
    <h1>{{ "quoteCart.emptyCartHeading" | cxTranslate }}</h1>
    <p>
      {{ "quoteCart.addProductPara" | cxTranslate }}
    </p>
    <div class="text-center add-btn-holder">
      <button class="vs-primary-btn add-button" (click)="goToAddProduct()">
        <i class="material-icons">add</i> {{ "quoteCart.emptyCartButtonText" | cxTranslate }}
      </button>

      <button class="vs-primary-btn add-button bulk-quote-btn" (click)="goToBulkOrder()">
        <i class="material-icons">add</i> {{ "quoteCart.bulkOrderButtonText" | cxTranslate }}
      </button>
    </div>
  </div>
</div>


